module.exports = "https://health.dajiuxing.com.cn/img/views/aboutUs/img/org-structure.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2FaboutUs%2Fimg%2Forg-structure.png
// module id = lIil
// module chunks = 93